import React from 'react';
export function Footer() {
  return <footer className="bg-gray-50 py-12 px-4 border-t border-gray-200" data-id="element-64">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-65">
        <p className="text-gray-500 text-sm" data-id="element-66">
          © {new Date().getFullYear()} Di Esto, No Aquello™. Todos los
          derechos reservados.
        </p>
        <div className="flex justify-center gap-6 text-sm text-gray-400" data-id="element-67">
          <a href="#" className="hover:text-gray-600" data-id="element-68">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gray-600" data-id="element-69">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gray-600" data-id="element-70">
            Contacto
          </a>
        </div>
        <p className="text-xs text-gray-300 max-w-lg mx-auto" data-id="element-71">
          Este producto no garantiza resultados específicos. Los resultados
          pueden variar. Este sitio no es parte del sitio web de Facebook o
          Facebook Inc. Además, este sitio no está respaldado por Facebook de
          ninguna manera.
        </p>
      </div>
    </footer>;
}